import { childForecasts, FORECASTS, ROLE_PLAIN, rootForecast, type Forecast } from "./forecasts";
import { proceduralMutations } from "./procedural";
import type { NetworkNode } from "./types";

const PALETTE = ["#73e0d2", "#f0bd68", "#ca8cff", "#427d68", "#cf9464"];
const ROLE_LAYER = {
  how: "inner" as const,
  where: "middle" as const,
  next: "outer" as const,
  kill: "outer" as const,
};

function toNode(f: Forecast, i: number, roleLabel: string, layer = f.layer): NetworkNode {
  return {
    id: f.id,
    name: f.claim,
    metricLabel: String(f.year),
    orbitLayer: layer,
    colorHex: PALETTE[i % PALETTE.length],
    cluster: roleLabel,
    signalLabel: String(f.year),
    why: `${f.test} If this is wrong: ${f.disprove}`,
    relation: roleLabel,
  };
}

function resolveParent(topic: string, parentId?: string): Forecast | undefined {
  if (parentId) return FORECASTS.find((f) => f.id === parentId);
  const exact = FORECASTS.find((f) => f.claim === topic || f.id === topic);
  if (exact) return exact;
  return rootForecast(topic);
}

export function scanSignals(topic: string, parentId?: string, visited: string[] = [], depth = 0): NetworkNode[] {
  const parent = resolveParent(topic, parentId);
  const seen = new Set(visited.filter(Boolean));
  const names = new Set<string>([topic.toLowerCase()]);
  const out: NetworkNode[] = [];
  if (parent) {
    seen.add(parent.id);
    names.add(parent.claim.toLowerCase());
    for (const row of childForecasts(parent, seen)) {
      const f = row.forecast;
      if (seen.has(f.id)) continue;
      const key = f.claim.toLowerCase();
      if (names.has(key)) continue;
      seen.add(f.id);
      names.add(key);
      out.push(toNode(f, out.length, ROLE_PLAIN[row.role], ROLE_LAYER[row.role]));
    }
  }
  if (out.length < 4) {
    for (const n of proceduralMutations(topic, depth, 4 - out.length)) {
      if (names.has(n.name.toLowerCase())) continue;
      names.add(n.name.toLowerCase());
      out.push(n);
    }
  }
  return out;
}
